export default "__VITE_ASSET__Z5uEC4XM__"